var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1501 33.0974L30.5683 22.478C30.391 22.2125 30.0364 22.2125 29.7615 22.3895C29.4956 22.5665 29.4956 22.9204 29.6729 23.1948L38.2547 33.8142C38.3433 33.9912 38.5206 33.9912 38.6979 33.9912C38.7866 33.9912 38.9639 33.9912 39.0526 33.9027C39.3185 33.7257 39.4072 33.3718 39.1412 33.0974H39.1501Z",
    fill: "url(#paint0_linear_484_267)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0294 7.04426C36.4726 2.49559 30.4795 0 24.0432 0C17.6068 0 11.6227 2.49559 7.05694 7.04426C2.50008 11.5929 0 17.5752 0 24C0 27.8407 0.895431 31.5841 2.67739 34.9735C3.75012 37.115 5.17745 39.0796 6.87962 40.7699C11.4365 45.4071 17.5182 48 24.0432 48C30.5682 48 36.6499 45.4159 41.2068 40.7699C43.0862 38.8938 44.6022 36.7522 45.675 34.3451C47.191 31.1328 47.9977 27.6549 47.9977 23.9912C48.0864 17.5664 45.5863 11.5929 41.0294 7.03541V7.04426ZM24.0432 1.15932C36.6499 1.15932 46.925 11.4159 46.925 24C46.925 27.1239 46.2955 30.1593 45.0455 33.0089L30.7455 15.2566C30.6568 15.1682 30.4795 15.0796 30.3022 15.0796C30.1249 15.0796 29.9476 15.1682 29.859 15.2566L18.1476 29.7965L12.8727 23.2832V17.9292H22.9705C23.2364 17.9292 23.5024 17.6637 23.5024 17.3982C23.5024 17.2212 23.4137 17.1327 23.3251 17.0443L20.825 14.0974L23.3251 11.1504C23.5024 10.9735 23.5024 10.7965 23.4137 10.5221C23.3251 10.3451 23.1478 10.1682 22.8818 10.1682H12.3319C12.0659 10.1682 11.8 10.4336 11.8 10.6991V23.2832L3.30683 33.7257C1.87949 30.6903 1.16138 27.4779 1.16138 24.0885C1.16138 11.4159 11.4365 1.15932 24.0432 1.15932ZM40.5773 39.7876H26.2773L18.8569 30.6903L30.3022 16.5044L44.6022 34.1681C43.5295 36.2212 42.1908 38.1858 40.5773 39.7876ZM7.50906 39.7876C6.08172 38.2743 4.83168 36.5752 3.84762 34.6991L12.3408 24.3451L17.6157 30.8584C17.6157 30.9469 17.7044 31.0354 17.793 31.1239H17.8817L24.8499 39.7788H7.50906V39.7876ZM19.7523 14.3628L21.8091 16.7699H12.9613V11.1504H21.8091L19.7523 13.5575C19.575 13.823 19.575 14.0973 19.7523 14.3628ZM8.67044 40.9469H39.4159C35.2137 44.7876 29.7614 46.8319 24.0432 46.8319C18.3249 46.8319 12.8727 44.7788 8.67044 40.9469Z",
    fill: "url(#paint1_linear_484_267)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_484_267",
    x1: 34.4256,
    y1: 22.2661,
    x2: 34.4256,
    y2: 33.9912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_484_267",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.40380eee3c69f1e01b96ea2c76a29517.svg";
export { ForwardRef as ReactComponent };